module.exports = __webpack_public_path__ + "media/40.91402a3e.mp3";